var _svg;
import React from "react";
const RespondNewIcon = ({
  ...rest
}) => {
  return _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22",
    fill: "#3372FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 12H15C13.3439 12.0018 12.0018 13.3439 12 15V25C12.0018 26.6561 13.3439 27.9982 15 28H27.293L31.1465 31.8535C31.2402 31.9473 31.3674 32 31.5 32C31.7761 32 32 31.7761 32 31.5V15C31.9982 13.3439 30.6561 12.0018 29 12ZM31 30.293L27.8535 27.1465C27.7598 27.0527 27.6326 27 27.5 27H15C13.8959 26.9987 13.0013 26.1041 13 25V15C13.0013 13.8959 13.8959 13.0013 15 13H29C30.104 13.0014 30.9986 13.896 31 15V30.293Z",
    fill: "white"
  })));
};
export default RespondNewIcon;